import BaseType from "../BaseType";

export default class Role extends BaseType {
  Name: string = "";
  Description: string = "";
}
